import { useRecalProcessAndGenMaintenanceTracked } from "presentation/store/Recalculation/RecalProcessAndGenMaintenanceProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import RecalProcessAndGenEditPanel from "./RecalProcessAndGenEditPanel";
import RecalProcessAndGenGeneratePanel from "./RecalProcessAndGenGeneratePanel";
import RecalProcessAndGenGenerateRightPanel from "./RecalProcessAndGenGenerateRightPanel";
import RecalProcessAndGenTablePanel from "./RecalProcessAndGenTablePanel";

const RecalProcessAndGenRightPanel = () => {
    const [recalProcessAndGenState] = useRecalProcessAndGenMaintenanceTracked();
    const { isShowGeneratePanel, isShowSubmitPanel, isShowEditPanel } = recalProcessAndGenState;

    return <>
        <div className={`main-comp-wrapper${(isShowGeneratePanel || isShowSubmitPanel || isShowEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={true}
                leftSectionWidth={(isShowGeneratePanel) ? "60%" : (isShowSubmitPanel ? "30%" : (isShowEditPanel ? "70%" : "100%"))}
                rightSectionWidth={(isShowGeneratePanel) ? "40%" : (isShowSubmitPanel ? "70%" : (isShowEditPanel ? "30%" : "0%"))}
                leftChildren={<RecalProcessAndGenTablePanel />}
                rightChildren={isShowGeneratePanel ? <RecalProcessAndGenGeneratePanel /> : (isShowSubmitPanel ? <RecalProcessAndGenGenerateRightPanel /> : (isShowEditPanel ? <RecalProcessAndGenEditPanel /> : <></>))}
            />
        </div>
    </>
}

export default RecalProcessAndGenRightPanel;
